import React from "react";
import "./Career.css";

const CareerTab = () => {
  return (
    <div>
      <div className="chains">
        <ul className="careerList">
          <li className="careerItem">
            <a rel="noreferrer" target="_blank" href="https://www.web-bee.ru/">
              Web bee
            </a>
          </li>
          <li className="betweener"></li>
          <li className="careerItem">
            <a rel="noreferrer" target="_blank" href="https://inquire.dev/">
              Inquire
            </a>
          </li>
          <li className="betweener"></li>
          <li className="careerItem">To be continued...</li>
        </ul>
      </div>
    </div>
  );
};

export default CareerTab;
